const LoadingSpinner = ({ pastDelay }) => {
	return pastDelay ? <div className="spinner" /> : null;
};

export default LoadingSpinner;
